import React, { useState } from 'react';
import { useSnackbarContext } from '../../contexts/Snackbar';
import { useEventTrackerContext } from '../../contexts/EventTracker';
import messages from '../../messages';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ContentContainer from '../BuildingBlocks/Container/ContentContainer';
import Typography from '@material-ui/core/Typography';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import TermCheckList from '../Onboarding/BuildingBlocks/TermsCheckList';
import ConnectBank from '../Bank/ConnectBank';
import NextButton from './NextButton';
import AcceptTerms from './AcceptTerms';
import AccountsComplete from './AccountsComplete';

const useStyles = makeStyles((theme: any) => ({
  header: {
    fontWeight: 'bold',
    textAlign: 'center',
    marginTop: theme.spacing(2),
  },
  iconContainer: { display: 'flex', justifyContent: 'center' },
  icon: { fontSize: 100 },
  description: { fontSize: '1.2em' },
  hasBank: { marginTop: theme.spacing(3) },
  bankConnected: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
}));

export default function Bank({
  plaidLinkToken,
  hasBank,
  setHasBank,
  goForward,
  mobile = false,
}) {
  const classes = useStyles();
  const snackbar = useSnackbarContext();
  const { trackEvent } = useEventTrackerContext();
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  async function handleSubmit() {
    if (!hasBank) {
      if (!acceptedTerms) {
        snackbar.show(messages.general.acceptTerms);
        return;
      }
      trackEvent({ event: 'skipped_bank_connection' });
    }
    goForward();
  }

  const headerText = mobile
    ? 'One last step.'
    : 'Before you submit, connect a bank account.';

  return (
    <ContentContainer width={600}>
      {!mobile && (
        <div className={classes.iconContainer}>
          <AccountBalanceIcon className={classes.icon} />
        </div>
      )}
      {hasBank && <AccountsComplete isHangTight={false} />}
      {!hasBank && (
        <>
          <Typography
            variant="h5"
            component="h5"
            paragraph={mobile}
            className={classes.header}
          >
            {headerText}
          </Typography>
          <Typography paragraph className={classes.description}>
            As part of our risk assessment protocol, <br />
            we ask that you link your business bank account.
          </Typography>
          <TermCheckList />
          <ConnectBank
            plaidLinkToken={plaidLinkToken}
            onSuccess={() => setHasBank(true)}
            buttonText="Link Bank Account"
            buttonFontSize={1.3}
            buttonMinWidth={200}
          />
        </>
      )}
      <NextButton onClick={handleSubmit} isPrimary={hasBank} />
      {!hasBank && (
        <AcceptTerms
          acceptedTerms={acceptedTerms}
          setAcceptedTerms={setAcceptedTerms}
        />
      )}
    </ContentContainer>
  );
}
